"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function StarIcon(_a) {
    var { backgroundColor } = _a, props = __rest(_a, ["backgroundColor"]);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "36", height: "35", viewBox: "0 0 36 35" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: backgroundColor, fillRule: "nonzero", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.8", d: "M17.763 1a.733.733 0 0 0-.657.51l-3.66 11.102H1.726v.001a.726.726 0 0 0-.69.507.745.745 0 0 0 .26.823l9.52 7.04-3.66 11.49v-.002a.74.74 0 0 0 .266.825.72.72 0 0 0 .857-.001l9.52-7.04 9.52 7.04c.255.188.6.19.857.001a.74.74 0 0 0 .266-.825l-3.66-11.49 9.52-7.039v.001a.745.745 0 0 0 .26-.823.726.726 0 0 0-.69-.507h-11.72l-3.66-11.102v-.002a.73.73 0 0 0-.729-.508z" }) })));
}
exports.default = StarIcon;
